<template>
  <div class="mydayPowerQuality2">
    <el-tabs v-model="activeName">
      <el-tab-pane label="日电能质量" name="first">
        <dayPowerQuality></dayPowerQuality>
      </el-tab-pane>
      <el-tab-pane label="月电能质量" name="second">
        <monthPowerQuality></monthPowerQuality>
      </el-tab-pane>
      <el-tab-pane label="年电能质量" name="third">
        <yearPowerQuality></yearPowerQuality>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/javascript">
import dayPowerQuality from "./dayPowerQuality.vue";
import monthPowerQuality from "./monthPowerQuality.vue";
import yearPowerQuality from "./yearPowerQuality.vue";
import { getCountPower } from "../../api/abbNewApi";
let proportion2;
export default {
  components: {
    dayPowerQuality,
    monthPowerQuality,
    yearPowerQuality,
  },
  props: [],
  data() {
    return {
      activeName: "first",
    };
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    checkFun(val) {
      this.copynowVirtualDevice = val;
    },
    selectDate(date) {
      this.$store.cacheStore.commit("setNowSelectDate", date);
      this.$refs.datePicker.hide();
    },
    //新下拉框
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        let valueList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
          valueList.push(item.value);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = valueList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    getSearch() {
      this.nowVirtualDevice = this.copynowVirtualDevice;
      this.search();
    },

    search() {
      if (isempty(this.virtualDeviceList)) {
        return;
      }
      if (this.nowVirtualDevice == undefined) {
        this.$dialogMethod.showMessage("请先选中设备！");
        return;
      }
      // if (isempty(this.allVariableName)) {
      // 	return
      // }
      var deviceArr = this.nowVirtualDevice.filter(
        (item) => item.type == "virtualDevice"
      );
      var deviceStr = "";
      deviceArr.forEach((item) => {
        deviceStr += "," + item.no;
      });
      var str = "";
      this.apptypeValue.forEach((item) => {
        str += "," + item;
      });
      // console.log("字符串",str.slice(1));
      var d = {
        dateType: "day",
        deviceNo: deviceStr.slice(1),
        electricPower: str.slice(1),
        time: this.dayTimer.getTime(),
      };

      this.loading = true;

      getCountPower(d).then((res) => {
        // console.log("热水",res);
        if (res.code == 200) {
          this.dataList = [];
          this.reloadChart(res.data);
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      });
      return;
    },
    exportExcel() {},
    init() {
      proportion2 = echarts.init(document.getElementById("proportion2"));
      proportion2.setOption(this.proportionData, true);
      // proportion2.resize({height: 500});

      // $(window).resize(function() {
      //   proportion2.resize({height: 500});
      // });
    },

    reloadChart(lists) {
      var legendData = [];
      var seriesData = [];
      var index = 0;
      for (let k in lists) {
        for (let v in lists[k]) {
          legendData.push({
            name: k + " " + this.convertName(v),
            icon: "roundRect",
          });

          this.dataList.push({
            name: k + " " + this.convertName(v),
          });
          seriesData.push({
            name: k + " " + this.convertName(v),
            data: [],
            type: "line",
            stack: "total",
            emphasis: {
              focus: "series",
            },
          });

          for (let t in lists[k][v]) {
            seriesData[index].data.push(lists[k][v][t]);
            this.dataList[index][t] = lists[k][v][t];
          }
          index += 1;
        }
      }
      this.proportionData.series = seriesData;
      this.proportionData.legend.data = legendData;
      console.log("this.proportionData", this.proportionData);
      proportion2.setOption(this.proportionData, true);
    },
    convertName(name) {
      if (name == "voltageUnbalance") {
        return "电流不平衡";
      } else if (name == "currentUnbalance") {
        return "电压不平衡";
      } else if (name == "frequencyDeviation") {
        return "频率偏差";
      } else if (nam == "voltageDistortionRate") {
        return "电压谐波畸变率";
      } else if (nam == "oddHarmonicInclusionRate") {
        return "奇数谐波含有率";
      } else if (nam == "evenHarmonicInclusionRate") {
        return "偶数谐波含有率";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mydayPowerQuality2 {
  background-color: #fff;
  padding: 10px;
}
</style>
